import { TrackingEventCategories as BaseTrackingEventCategories } from '../../common/tracking/tracking-event-categories.model';

export const TrackingEventCategories = {
  ...BaseTrackingEventCategories
};
